import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import { Link } from "react-router-dom";
import "chart.js/auto";
import {
  getpastperformaceFuturedata,
  getpastperformaceCashdata,
  getpastperformacebymonth,
} from "../../../Services/UserService/User";
import Content from "../../../components/Contents/Content";
import Table from "../../../Extracomponents/Table";
import { fDateTime } from "../../../../Utils/Date_formate";
import { Tooltip } from "antd";
import {
  SquarePen,
  Trash2,
  PanelBottomOpen,
  Eye,
  ArrowDownToLine,
  IndianRupee,
} from "lucide-react";
import ReusableModal from "../../../components/Models/ReusableModal";

const Cash = () => {
  const token = localStorage.getItem("token");

  const [cashPastData, setCashPastdata] = useState(new Array(12).fill(0));
  const [monthaverg, setMonthaverg] = useState({});

  const today = new Date();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  const currentYear = today.getFullYear();

  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [chartData1, setChartData1] = useState(null);
  const [doughnutData1, setDoughnutData1] = useState(null);
  const [dailydata, setDailydata] = useState([]);
  const [description, setDescription] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [cashChartData, setCashChartData] = useState(null);
  const [futureAvgProfit, setFutureAvgProfit] = useState(0);
  const [oneMonth, setOneMonth] = useState(0);
  const [doughnutOptions, setDoughnutOptions] = useState({});

  const months = [
    { name: "Jan", value: "01" },
    { name: "Feb", value: "02" },
    { name: "Mar", value: "03" },
    { name: "Apr", value: "04" },
    { name: "May", value: "05" },
    { name: "Jun", value: "06" },
    { name: "Jul", value: "07" },
    { name: "Aug", value: "08" },
    { name: "Sep", value: "09" },
    { name: "Oct", value: "10" },
    { name: "Nov", value: "11" },
    { name: "Dec", value: "12" },
  ];

  useEffect(() => {
    getCashpastdata();
  }, []);

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66dfede64a88602fbbca9b72" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Net Profit
  //       setOneMonth(allDurations["1_month"]?.totalNetProfit);

  //       // 🔹 Future Avg Profit (last duration)
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];
  //       setFutureAvgProfit(lastDuration?.totalNetProfit || 0);

  //       // 🔹 Month-wise combined data for all durations
  //       const monthWiseProfitLoss = {};
  //       Object.values(allDurations).forEach((duration) => {
  //         const months = duration.months || {};
  //         Object.entries(months).forEach(([month, data]) => {
  //           if (!monthWiseProfitLoss[month]) {
  //             monthWiseProfitLoss[month] = {
  //               totalProfit: data.totalProfit ?? 0,
  //               totalLoss: data.totalLoss ?? 0,
  //               netProfit: data.netProfit ?? 0,
  //             };
  //           }
  //         });
  //       });

  //       // 🔹 Sorted months
  //       const sortedMonths = Object.keys(monthWiseProfitLoss).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Chart values
  //       const chartValues = sortedMonths.map((month) => monthWiseProfitLoss[month].netProfit);

  //       // 🔹 Labels
  //       const labels = sortedMonths.map((m) => {
  //         const [year, month] = m.split("-");
  //         return new Date(year, month - 1).toLocaleString("default", {
  //           month: "short",
  //           year: "2-digit",
  //         });
  //       });

  //       // 🔹 Set chart data
  //       setCashChartData({
  //         labels,
  //         datasets: [
  //           {
  //             label: "Net Profit",
  //             data: chartValues,
  //             backgroundColor: chartValues.map((v) =>
  //               v >= 0 ? "rgba(15, 230, 122, 0.6)" : "rgba(236, 34, 19, 0.6)"
  //             ),
  //             hoverBackgroundColor: chartValues.map((v) =>
  //               v >= 0 ? "rgba(15, 230, 122, 1)" : "rgba(236, 34, 19, 1)"
  //             ),
  //             borderRadius: 5,
  //             barThickness: 100,
  //             maxBarThickness: 120,
  //             minBarLength: 10, // ✅ minimum height in pixels
  //           },
  //         ],

  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: false,
  //           plugins: {
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const month = sortedMonths[context.dataIndex];
  //                   const { totalProfit, totalLoss, netProfit } = monthWiseProfitLoss[month] || {};
  //                   return `Profit: ${totalProfit.toFixed(2)}, Loss: ${totalLoss.toFixed(2)}, Net: ${netProfit.toFixed(2)}`;
  //                 },
  //               },
  //             },
  //           },
  //           interaction: {
  //             mode: "nearest",
  //             intersect: false,
  //           },
  //           hover: {
  //             mode: "index",
  //             intersect: false,
  //           },
  //           scales: {
  //             y: {
  //               ticks: {
  //                 callback: (value) => value.toFixed(2),
  //               },
  //             },
  //           },
  //         },
  //       });

  //       // 🔹 Set chart values in state if needed
  //       setCashPastdata(chartValues);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66dfede64a88602fbbca9b72" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Net Profit
  //       setOneMonth(allDurations["1_month"]?.totalNetProfit);

  //       // 🔹 Future Avg Profit (last duration)
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];
  //       setFutureAvgProfit(lastDuration?.totalNetProfit || 0);

  //       // 🔹 Month-wise combined data for all durations
  //       const monthWiseProfitLoss = {};
  //       Object.values(allDurations).forEach((duration) => {
  //         const months = duration.months || {};
  //         Object.entries(months).forEach(([month, data]) => {
  //           if (!monthWiseProfitLoss[month]) {
  //             monthWiseProfitLoss[month] = {
  //               totalProfit: data.totalProfit ?? 0,
  //               totalLoss: data.totalLoss ?? 0,
  //               netProfit: data.netProfit ?? 0,
  //             };
  //           }
  //         });
  //       });

  //       // 🔹 Sorted months
  //       const sortedMonths = Object.keys(monthWiseProfitLoss).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Separate Profit and Loss Data
  //       const profitData = [];
  //       const lossData = [];

  //       sortedMonths.forEach((month) => {
  //         const netProfit = monthWiseProfitLoss[month].netProfit;

  //         if (netProfit >= 0) {
  //           profitData.push(netProfit);
  //           lossData.push(null); // No bar for loss dataset
  //         } else {
  //           profitData.push(null); // No bar for profit dataset
  //           lossData.push(netProfit);
  //         }
  //       });

  //       // 🔹 Labels
  //       const labels = sortedMonths.map((m) => {
  //         const [year, month] = m.split("-");
  //         return new Date(year, month - 1).toLocaleString("default", {
  //           month: "short",
  //           year: "2-digit",
  //         });
  //       });

  //       // 🔹 Set chart data with TWO DATASETS
  //       setCashChartData({
  //         labels,
  //         datasets: [
  //           {
  //             label: "Profit",
  //             data: profitData,
  //             backgroundColor: "rgba(15, 230, 122, 0.8)",
  //             hoverBackgroundColor: "rgba(15, 230, 122, 1)",
  //             borderColor: "rgba(15, 230, 122, 1)",
  //             borderWidth: 1,
  //             borderRadius: 5,
  //             barThickness: 100,
  //             maxBarThickness: 120,
  //             minBarLength: 10,
  //             // Store data for filtering
  //             allMonths: sortedMonths,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //           {
  //             label: "Loss",
  //             data: lossData,
  //             backgroundColor: "rgba(236, 34, 19, 0.8)",
  //             hoverBackgroundColor: "rgba(236, 34, 19, 1)",
  //             borderColor: "rgba(236, 34, 19, 1)",
  //             borderWidth: 1,
  //             borderRadius: 5,
  //             barThickness: 100,
  //             maxBarThickness: 120,
  //             minBarLength: 10,
  //             // Store data for filtering
  //             allMonths: sortedMonths,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: false,
  //           plugins: {
  //             legend: {
  //               display: true,
  //               position: 'top',
  //               labels: {
  //                 color: '#ffffff',
  //                 font: {
  //                   size: 13,
  //                   weight: '600'
  //                 },
  //                 padding: 15,
  //                 usePointStyle: true,
  //                 pointStyle: 'rect',
  //                 boxWidth: 30,
  //                 boxHeight: 15,
  //               },
  //               onClick: function (e, legendItem, legend) {
  //                 const chart = legend.chart;
  //                 const datasetIndex = legendItem.datasetIndex;
  //                 const dataset = chart.data.datasets[0];
  //                 const allMonths = dataset.allMonths;
  //                 const monthWiseProfitLoss = dataset.monthWiseProfitLoss;

  //                 let filteredMonths;

  //                 if (datasetIndex === 0) { // Profit clicked
  //                   filteredMonths = allMonths.filter(m => monthWiseProfitLoss[m].netProfit >= 0);
  //                 } else { // Loss clicked
  //                   filteredMonths = allMonths.filter(m => monthWiseProfitLoss[m].netProfit < 0);
  //                 }

  //                 if (filteredMonths.length === 0) {
  //                   filteredMonths = allMonths;
  //                 }

  //                 // Rebuild data for both datasets
  //                 const newProfitData = [];
  //                 const newLossData = [];

  //                 filteredMonths.forEach((month) => {
  //                   const netProfit = monthWiseProfitLoss[month].netProfit;

  //                   if (netProfit >= 0) {
  //                     newProfitData.push(netProfit);
  //                     newLossData.push(null);
  //                   } else {
  //                     newProfitData.push(null);
  //                     newLossData.push(netProfit);
  //                   }
  //                 });

  //                 chart.data.labels = filteredMonths.map((m) => {
  //                   const [year, month] = m.split("-");
  //                   return new Date(year, month - 1).toLocaleString("default", {
  //                     month: "short",
  //                     year: "2-digit",
  //                   });
  //                 });

  //                 chart.data.datasets[0].data = newProfitData;
  //                 chart.data.datasets[1].data = newLossData;

  //                 chart.update();
  //               }
  //             },
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const allMonths = context.chart.data.datasets[0].allMonths;
  //                   const monthWiseProfitLoss = context.chart.data.datasets[0].monthWiseProfitLoss;

  //                   // Find the actual month from filtered labels
  //                   const labelIndex = context.dataIndex;
  //                   const currentLabels = context.chart.data.labels;

  //                   // Match label to original month
  //                   let matchedMonth = null;
  //                   allMonths.forEach(month => {
  //                     const [year, m] = month.split("-");
  //                     const formattedLabel = new Date(year, m - 1).toLocaleString("default", {
  //                       month: "short",
  //                       year: "2-digit",
  //                     });
  //                     if (formattedLabel === currentLabels[labelIndex]) {
  //                       matchedMonth = month;
  //                     }
  //                   });

  //                   if (matchedMonth) {
  //                     const { totalProfit, totalLoss, netProfit } = monthWiseProfitLoss[matchedMonth] || {};
  //                     return `Profit: ${totalProfit.toFixed(2)}, Loss: ${totalLoss.toFixed(2)}, Net: ${netProfit.toFixed(2)}`;
  //                   }

  //                   return `Net: ${(context.raw || 0).toFixed(2)}`;
  //                 },
  //               },
  //             },
  //           },
  //           interaction: {
  //             mode: "nearest",
  //             intersect: false,
  //           },
  //           hover: {
  //             mode: "index",
  //             intersect: false,
  //           },
  //           scales: {
  //             y: {
  //               ticks: {
  //                 callback: (value) => value.toFixed(2),
  //                 color: '#ffffff'
  //               },
  //               grid: {
  //                 color: 'rgba(255, 255, 255, 0.1)'
  //               }
  //             },
  //             x: {
  //               ticks: {
  //                 color: '#ffffff'
  //               },
  //               grid: {
  //                 color: 'rgba(255, 255, 255, 0.1)'
  //               }
  //             }
  //           },
  //         },
  //       });

  //       // 🔹 Set chart values in state if needed
  //       const allValues = [...profitData, ...lossData].filter(v => v !== null);
  //       setCashPastdata(allValues);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  // const getCashpastdata = async () => {
  //   try {
  //     const response = await getpastperformaceCashdata(
  //       { id: "66dfede64a88602fbbca9b72" },
  //       token
  //     );

  //     if (response?.status) {
  //       const allDurations = response.data;

  //       // 🔹 1 Month Net Profit
  //       setOneMonth(allDurations["1_month"]?.totalNetProfit);

  //       // 🔹 Future Avg Profit (last duration)
  //       const durationKeys = Object.keys(allDurations);
  //       const lastKey = durationKeys[durationKeys.length - 1] || "";
  //       const lastDuration = allDurations[lastKey];
  //       setFutureAvgProfit(lastDuration?.totalNetProfit || 0);

  //       // 🔹 Month-wise combined data for all durations
  //       const monthWiseProfitLoss = {};
  //       Object.values(allDurations).forEach((duration) => {
  //         const months = duration.months || {};
  //         Object.entries(months).forEach(([month, data]) => {
  //           if (!monthWiseProfitLoss[month]) {
  //             monthWiseProfitLoss[month] = {
  //               totalProfit: data.totalProfit ?? 0,
  //               totalLoss: data.totalLoss ?? 0,
  //               netProfit: data.netProfit ?? 0,
  //             };
  //           }
  //         });
  //       });

  //       // 🔹 Sorted months
  //       const sortedMonths = Object.keys(monthWiseProfitLoss).sort((a, b) => {
  //         const [yearA, monthA] = a.split("-").map(Number);
  //         const [yearB, monthB] = b.split("-").map(Number);
  //         return yearA - yearB || monthA - monthB;
  //       });

  //       // 🔹 Separate Profit and Loss Data
  //       const profitData = [];
  //       const lossData = [];

  //       sortedMonths.forEach((month) => {
  //         const netProfit = monthWiseProfitLoss[month].netProfit;
  //         if (netProfit >= 0) {
  //           profitData.push(netProfit);
  //           lossData.push(null);
  //         } else {
  //           profitData.push(null);
  //           lossData.push(netProfit);
  //         }
  //       });

  //       // 🔹 Labels
  //       const labels = sortedMonths.map((m) => {
  //         const [year, month] = m.split("-");
  //         return new Date(year, month - 1).toLocaleString("default", {
  //           month: "short",
  //           year: "2-digit",
  //         });
  //       });

  //       // 🔹 Set chart data with TWO DATASETS
  //       setCashChartData({
  //         labels,
  //         datasets: [
  //           {
  //             label: "Profit",
  //             data: profitData,
  //             backgroundColor: "rgba(15, 230, 122, 0.8)",
  //             hoverBackgroundColor: "rgba(15, 230, 122, 1)",
  //             borderColor: "rgba(15, 230, 122, 1)",
  //             borderWidth: 1,
  //             borderRadius: 5,
  //             barThickness: 100,
  //             maxBarThickness: 120,
  //             minBarLength: 10,
  //             barPercentage: 0.6,       // ← bar alignment fix
  //             categoryPercentage: 0.7,  // ← bar alignment fix
  //             allMonths: sortedMonths,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //           {
  //             label: "Loss",
  //             data: lossData,
  //             backgroundColor: "rgba(236, 34, 19, 0.8)",
  //             hoverBackgroundColor: "rgba(236, 34, 19, 1)",
  //             borderColor: "rgba(236, 34, 19, 1)",
  //             borderWidth: 1,
  //             borderRadius: 5,
  //             barThickness: 100,
  //             maxBarThickness: 120,
  //             minBarLength: 10,
  //             barPercentage: 0.6,       // ← bar alignment fix
  //             categoryPercentage: 0.7,  // ← bar alignment fix
  //             allMonths: sortedMonths,
  //             monthWiseProfitLoss: monthWiseProfitLoss,
  //           },
  //         ],
  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: false,
  //           plugins: {
  //             legend: {
  //               display: true,
  //               position: 'top',
  //               labels: {
  //                 color: '#ffffff',
  //                 font: { size: 13, weight: '600' },
  //                 padding: 15,
  //                 usePointStyle: true,
  //                 pointStyle: 'rect',
  //                 boxWidth: 30,
  //                 boxHeight: 15,
  //               },
  //               onClick: function (e, legendItem, legend) {
  //                 const chart = legend.chart;
  //                 const datasetIndex = legendItem.datasetIndex;
  //                 const dataset = chart.data.datasets[0];
  //                 const allMonths = dataset.allMonths;
  //                 const monthWiseProfitLoss = dataset.monthWiseProfitLoss;

  //                 let filteredMonths;
  //                 if (datasetIndex === 0) {
  //                   filteredMonths = allMonths.filter(m => monthWiseProfitLoss[m].netProfit >= 0);
  //                 } else {
  //                   filteredMonths = allMonths.filter(m => monthWiseProfitLoss[m].netProfit < 0);
  //                 }
  //                 if (filteredMonths.length === 0) filteredMonths = allMonths;

  //                 const newProfitData = [];
  //                 const newLossData = [];

  //                 filteredMonths.forEach((month) => {
  //                   const netProfit = monthWiseProfitLoss[month].netProfit;
  //                   if (netProfit >= 0) {
  //                     newProfitData.push(netProfit);
  //                     newLossData.push(null);
  //                   } else {
  //                     newProfitData.push(null);
  //                     newLossData.push(netProfit);
  //                   }
  //                 });

  //                 chart.data.labels = filteredMonths.map((m) => {
  //                   const [year, month] = m.split("-");
  //                   return new Date(year, month - 1).toLocaleString("default", {
  //                     month: "short",
  //                     year: "2-digit",
  //                   });
  //                 });

  //                 chart.data.datasets[0].data = newProfitData;
  //                 chart.data.datasets[1].data = newLossData;

  //                 chart.update();
  //               }
  //             },
  //             tooltip: {
  //               callbacks: {
  //                 label: function (context) {
  //                   const allMonths = context.chart.data.datasets[0].allMonths;
  //                   const monthWiseProfitLoss = context.chart.data.datasets[0].monthWiseProfitLoss;
  //                   const labelIndex = context.dataIndex;
  //                   const currentLabels = context.chart.data.labels;

  //                   let matchedMonth = null;
  //                   allMonths.forEach(month => {
  //                     const [year, m] = month.split("-");
  //                     const formattedLabel = new Date(year, m - 1).toLocaleString("default", {
  //                       month: "short",
  //                       year: "2-digit",
  //                     });
  //                     if (formattedLabel === currentLabels[labelIndex]) matchedMonth = month;
  //                   });

  //                   if (matchedMonth) {
  //                     const { totalProfit, totalLoss, netProfit } = monthWiseProfitLoss[matchedMonth] || {};
  //                     return `Profit: ${totalProfit.toFixed(2)}, Loss: ${totalLoss.toFixed(2)}, Net: ${netProfit.toFixed(2)}`;
  //                   }

  //                   return `Net: ${(context.raw || 0).toFixed(2)}`;
  //                 },
  //               },
  //             },
  //           },
  //           interaction: { mode: "nearest", intersect: false },
  //           hover: { mode: "index", intersect: false },
  //           scales: {
  //             y: {
  //               ticks: { callback: (value) => value.toFixed(2), color: '#ffffff' },
  //               grid: { color: 'rgba(255, 255, 255, 0.1)' }
  //             },
  //             x: {
  //               offset: true, // ← fix bar alignment with label
  //               ticks: { color: '#ffffff' },
  //               grid: { color: 'rgba(255, 255, 255, 0.1)' }
  //             }
  //           },
  //         },
  //       });

  //       const allValues = [...profitData, ...lossData].filter(v => v !== null);
  //       setCashPastdata(allValues);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching Cash data:", error);
  //   }
  // };

  const getCashpastdata = async () => {
    try {
      const response = await getpastperformaceCashdata(
        { id: "66dfede64a88602fbbca9b72" },
        token
      );

      if (response?.status) {
        const allDurations = response.data;

        // 🔹 1 Month Net Profit
        setOneMonth(allDurations["1_month"]?.totalNetProfit);

        // 🔹 Future Avg Profit
        const durationKeys = Object.keys(allDurations);
        const lastKey = durationKeys[durationKeys.length - 1] || "";
        const lastDuration = allDurations[lastKey];
        setFutureAvgProfit(lastDuration?.totalNetProfit || 0);

        // 🔹 Month-wise combined data
        const monthWiseProfitLoss = {};
        Object.values(allDurations).forEach((duration) => {
          const months = duration.months || {};
          Object.entries(months).forEach(([month, data]) => {
            if (!monthWiseProfitLoss[month]) {
              monthWiseProfitLoss[month] = {
                totalProfit: data.totalProfit ?? 0,
                totalLoss: data.totalLoss ?? 0,
                netProfit: data.netProfit ?? 0,
              };
            }
          });
        });

        // 🔹 Sorted months
        const sortedMonths = Object.keys(monthWiseProfitLoss).sort((a, b) => {
          const [yearA, monthA] = a.split("-").map(Number);
          const [yearB, monthB] = b.split("-").map(Number);
          return yearA - yearB || monthA - monthB;
        });

        // 🔹 Separate Profit & Loss
        const profitData = [];
        const lossData = [];

        sortedMonths.forEach((month) => {
          const netProfit = monthWiseProfitLoss[month].netProfit;
          if (netProfit >= 0) {
            profitData.push(netProfit);
            lossData.push(null);
          } else {
            profitData.push(null);
            lossData.push(netProfit);
          }
        });

        // 🔹 Labels
        const labels = sortedMonths.map((m) => {
          const [year, month] = m.split("-");
          return new Date(year, month - 1).toLocaleString("default", {
            month: "short",
            year: "2-digit",
          });
        });

        // 🔹 Chart Data
        // setCashChartData({
        //   labels,
        //   datasets: [
        //     {
        //       label: "Profit",
        //       data: profitData,
        //       backgroundColor: "rgba(15, 230, 122, 0.8)",
        //       borderColor: "rgba(15, 230, 122, 1)",
        //       borderWidth: 1,
        //       borderRadius: 2,
        //       barPercentage: 0.6,
        //       categoryPercentage: 0.7,
        //       allMonths: sortedMonths,
        //       monthWiseProfitLoss: monthWiseProfitLoss,
        //     },
        //     {
        //       label: "Loss",
        //       data: lossData,
        //       backgroundColor: "rgba(236, 34, 19, 0.8)",
        //       borderColor: "rgba(236, 34, 19, 1)",
        //       borderWidth: 1,
        //       borderRadius: 2,
        //       barPercentage: 0.4,
        //       categoryPercentage: 0.5,
        //       allMonths: sortedMonths,
        //       monthWiseProfitLoss: monthWiseProfitLoss,
        //     },
        //   ],
        //   options: {
        //     responsive: true,
        //     maintainAspectRatio: false,
        //     plugins: {
        //       legend: {
        //         display: true,
        //         position: "top",
        //         labels: { color: "#ffffff", font: { size: 13, weight: "600" } },
        //       },
        //       tooltip: {
        //         callbacks: {
        //           label: function (context) {
        //             const allMonths = context.chart.data.datasets[0].allMonths;
        //             const monthWiseProfitLoss =
        //               context.chart.data.datasets[0].monthWiseProfitLoss;
        //             const labelIndex = context.dataIndex;
        //             const currentLabels = context.chart.data.labels;

        //             let matchedMonth = null;
        //             allMonths.forEach((month) => {
        //               const [year, m] = month.split("-");
        //               const formattedLabel = new Date(
        //                 year,
        //                 m - 1
        //               ).toLocaleString("default", {
        //                 month: "short",
        //                 year: "2-digit",
        //               });
        //               if (formattedLabel === currentLabels[labelIndex])
        //                 matchedMonth = month;
        //             });

        //             if (matchedMonth) {
        //               const { totalProfit, totalLoss, netProfit } =
        //                 monthWiseProfitLoss[matchedMonth] || {};
        //               return `Profit: ${totalProfit.toFixed(
        //                 2
        //               )}, Loss: ${totalLoss.toFixed(
        //                 2
        //               )}, Net: ${netProfit.toFixed(2)}`;
        //             }
        //             return `Net: ${(context.raw || 0).toFixed(2)}`;
        //           },
        //         },
        //       },
        //     },
        //     interaction: { mode: "nearest", intersect: false },
        //     hover: { mode: "index", intersect: false },
        //     scales: {
        //       y: {
        //         ticks: { callback: (v) => v.toFixed(2), color: "#ffffff" },
        //         grid: { color: "rgba(255, 255, 255, 0.1)" },
        //       },
        //       x: {
        //         offset: true, // align bars with labels
        //         ticks: { color: "#ffffff" },
        //         grid: { color: "rgba(255, 255, 255, 0.1)" },
        //       },
        //     },
        //   },
        // });

setCashChartData({
  labels,
  datasets: [
    {
      label: "Profit/Loss",
      data: sortedMonths.map((m) => monthWiseProfitLoss[m].netProfit),
      backgroundColor: sortedMonths.map((m) =>
        monthWiseProfitLoss[m].netProfit >= 0
          ? "rgba(15, 230, 122, 0.8)" // green for profit
          : "rgba(236, 34, 19, 0.8)" // red for loss
      ),
      borderColor: sortedMonths.map((m) =>
        monthWiseProfitLoss[m].netProfit >= 0
          ? "rgba(15, 230, 122, 1)"
          : "rgba(236, 34, 19, 1)"
      ),
      borderWidth: 1,
      borderRadius: 6,
      barThickness: "flex",       // ✅ same as top chart
      maxBarThickness: 45,        // ✅ same visual thickness
      minBarLength: 3,
      tooltipData: sortedMonths.map((m) => monthWiseProfitLoss[m]),
    },
  ],
  options: {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#ffffff",
          font: { size: 13, weight: "600" },
          padding: 15,
          usePointStyle: true,
          pointStyle: "rect",
          boxWidth: 30,
          boxHeight: 15,
          generateLabels: function () {
            return [
              {
                text: "Profit",
                fillStyle: "rgba(15, 230, 122, 0.8)",
                strokeStyle: "rgba(15, 230, 122, 1)",
              },
              {
                text: "Loss",
                fillStyle: "rgba(236, 34, 19, 0.8)",
                strokeStyle: "rgba(236, 34, 19, 1)",
              },
            ];
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const tooltipData = context.dataset.tooltipData[context.dataIndex];
            const { totalProfit, totalLoss, netProfit } = tooltipData || {};
            return `Profit: ${totalProfit?.toFixed(2) || 0}, Loss: ${totalLoss?.toFixed(
              2
            )}, Net: ${netProfit?.toFixed(2) || 0}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "#ffffff", maxRotation: 45, minRotation: 0 },
        grid: { display: false, color: "rgba(255,255,255,0.1)" },
      },
      y: {
        ticks: {
          color: "#ffffff",
          callback: (v) => v.toFixed(2),
        },
        grid: { color: "rgba(255,255,255,0.1)" },
        min:
          Math.min(...Object.values(monthWiseProfitLoss).map((v) => v.netProfit), 0) * 1.2,
        max:
          Math.max(...Object.values(monthWiseProfitLoss).map((v) => v.netProfit), 0) * 1.2,
      },
    },
  },
});



        // 🔹 Store values if needed
        const allValues = [...profitData, ...lossData].filter(
          (v) => v !== null
        );
        setCashPastdata(allValues);
      }
    } catch (error) {
      console.error("Error fetching Cash data:", error);
    }
  };

  const getPastPerformanceData = async () => {
    try {
      const data = { id: "66dfede64a88602fbbca9b72", month, year };
      const response = await getpastperformacebymonth(data, token);

      if (response?.status) {
        setDailydata(response?.data);
        const dailyData = response?.data?.dailyData || {};

        // 🔹 Line chart data
        const labels = Object.keys(dailyData);
        const netProfitData = labels.map(
          (date) => dailyData[date].netProfit || 0
        );

        const formattedChartData = {
          labels,
          datasets: [
            {
              label: "Net Profit",
              data: netProfitData,
              backgroundColor: netProfitData.map((value) =>
                value >= 0
                  ? "rgba(15, 230, 122, 0.6)"
                  : "rgba(236, 34, 19, 0.6)"
              ),
              borderColor: netProfitData.map((value) =>
                value >= 0 ? "blue" : "red"
              ),
              borderWidth: 1,
            },
          ],
        };

        setChartData1(formattedChartData);

        // 🔹 Doughnut chart raw data
        const rawDoughnutData = [
          {
            label: "Total Calls",
            value: response?.data?.totalSignals || 0,
            color: "#36A2EB",
          },
          {
            label: "Profitable Calls",
            value: response?.data?.profitableCalls || 0,
            color: "#81ff85ff",
          },
          {
            label: "Loss Calls",
            value: response?.data?.lossCalls || 0,
            color: "#FF6384",
          },
          {
            label: "Total Profit",
            value: response?.data?.totalProfit || 0,
            color: "#0ada3eff",
          },
          {
            label: "Total Loss",
            value: response?.data?.totalLoss || 0,
            color: "#FF4444",
          },
          {
            label: "Net Profit/Loss",
            value: response?.data?.netProfit || 0,
            color: "#0a5f30ff",
          },
        ];

        // 🔹 Filter out entries where value = 0
        const filteredData = rawDoughnutData.filter((item) => item.value !== 0);

        // 🔹 Scale data for visual representation
        const scaledDoughnutData = filteredData.map((item) =>
          Math.log(Math.abs(item.value) + 1)
        );

        const doughnutChartData = {
          labels: filteredData.map((item) => item.label),
          datasets: [
            {
              data: scaledDoughnutData,
              originalData: filteredData.map((item) => item.value),
              backgroundColor: filteredData.map((item) => item.color),
              hoverBackgroundColor: filteredData.map((item) => item.color),
            },
          ],
        };

        const options = {
          plugins: {
            tooltip: {
              callbacks: {
                label: function (context) {
                  const originalValue =
                    context.dataset.originalData[context.dataIndex];
                  return `${context.label}: ${Number(originalValue).toFixed(
                    2
                  )}`;
                },
              },
            },
          },
        };

        setDoughnutData1(doughnutChartData);
        setDoughnutOptions(options);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getPastPerformanceData();
  }, [month, year]);

  // const changeMonth = (direction) => {
  //   let currentIndex = months.findIndex((m) => m.value === month);
  //   if (direction === "prev") {
  //     currentIndex = currentIndex > 0 ? currentIndex - 1 : 11;
  //   } else {
  //     currentIndex = currentIndex < 11 ? currentIndex + 1 : 0;
  //   }
  //   setMonth(months[currentIndex].value);
  //   if (currentIndex === 11 && direction === "next") {
  //     setYear((prevYear) => (parseInt(prevYear) + 1).toString());
  //   } else if (currentIndex === 0 && direction === "prev") {
  //     setYear((prevYear) => (parseInt(prevYear) - 1).toString());
  //   }
  // };

  const changeMonth = (direction) => {
    const currentIndex = months.findIndex((m) => m.value === month);
    let newIndex = currentIndex;
    let newYear = parseInt(year);

    if (direction === "next") {
      if (currentIndex === 11) {
        // December → January of next year
        newIndex = 0;
        newYear += 1;
      } else {
        newIndex = currentIndex + 1;
      }
    } else if (direction === "prev") {
      if (currentIndex === 0) {
        // January → December of previous year
        newIndex = 11;
        newYear -= 1;
      } else {
        newIndex = currentIndex - 1;
      }
    }

    // Dono state updates ek saath karo
    const newMonth = months[newIndex].value;
    setMonth(newMonth);
    setYear(newYear.toString());
  };

  const chartData = {
    labels: [
      // "January", "February", "March", "April", "May", "June",
      // "July", "August", "September", "October", "November", "December"
    ],

    datasets: [
      {
        label: "Future",
        data: cashPastData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  const handleViewClick = (description) => {
    setDescription({ description });
  };

  const handleDownload = (row) => {
    const url = row.report_full_path;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const columns = [
    {
      name: "Stocks Name",
      selector: (row) => row?.stockName,
      sortable: true,
      width: "300px",
    },
    {
      name: "Entry Type",
      selector: (row) => row?.entryType,
      sortable: true,
      width: "200px",
    },
    {
      name: "Entry Date",
      selector: (row) => fDateTime(row.entryDate),
      sortable: true,
      width: "200px",
    },
    {
      name: "Entry Price",
      selector: (row) => (
        <div>
          {" "}
          <IndianRupee />
          {(row?.entryPrice).toFixed(2)}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Exit Date",
      selector: (row) => fDateTime(row.exitDate),
      sortable: true,
      width: "200px",
    },
    {
      name: "Exit Price",
      selector: (row) => (
        <div>
          {" "}
          <IndianRupee />
          {(row?.exitPrice).toFixed(2)}
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Net Gain/Loss",
      selector: (row) => row?.netGainLossPercent,
      sortable: true,
      width: "200px",
      conditionalCellStyles: [
        {
          when: (row) =>
            parseFloat(
              String(row?.netGainLossPercent || "").replace(/[^-0-9.]/g, "")
            ) < 0,
          style: { color: "red", fontWeight: "bold" },
        },
        {
          when: (row) =>
            parseFloat(
              String(row?.netGainLossPercent || "").replace(/[^-0-9.]/g, "")
            ) >= 0,
          style: { color: "green", fontWeight: "bold" },
        },
      ],
    },
    {
      name: "Description",
      cell: (row) => (
        <>
          <div>
            <Tooltip placement="top" overlay="View">
              <Eye
                onClick={() => {
                  handleViewClick([row.description]);
                  setShowModal(true);
                }}
              />
            </Tooltip>
          </div>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Report",
      cell: (row) => (
        <>
          {row.report_full_path ? (
            <div className="d-flex ">
              <Link className="btn px-2" onClick={() => handleDownload(row)}>
                <Tooltip placement="top" overlay="Download">
                  <ArrowDownToLine />
                </Tooltip>
              </Link>
            </div>
          ) : (
            "-"
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "200px",
    },
  ];

  const getPrevMonthYear = () => {
    const currentIndex = months.findIndex((m) => m.value === month);
    if (currentIndex === 0) {
      return { month: months[11].name, year: parseInt(year) - 1 };
    } else {
      return { month: months[currentIndex - 1].name, year: parseInt(year) };
    }
  };

  const getNextMonthYear = () => {
    const currentIndex = months.findIndex((m) => m.value === month);
    if (currentIndex === 11) {
      return { month: months[0].name, year: parseInt(year) + 1 };
    } else {
      return { month: months[currentIndex + 1].name, year: parseInt(year) };
    }
  };

  return (
    <Content
      Page_title="Future"
      button_status={false}
      backbutton_status={false}
      backForword={true}
    >
      <div className="page-content">
        <div className="row">
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  1 Month Average<span></span>
                </li>
                <li className="list-group-item d-flex  align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary  badgespan me-1">
                    <i className="bx bx-rupee fs-5 text-dark"></i>
                  </span>{" "}
                  {/* {monthaverg?.["1_month"]?.avgMonthlyProfit?.toFixed(2) || "-"} */}
                  <h4
                    className={`${
                      oneMonth < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {oneMonth.toFixed(2)}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  3 Month Average<span></span>
                </li>
                <li className="list-group-item d-flex  align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary  badgespan me-1">
                    <i className="bx bx-rupee fs-5 text-dark"></i>
                  </span>{" "}
                  {/* {monthaverg?.["3_months"]?.avgMonthlyProfit?.toFixed(2) || "-"} */}
                  <h4
                    className={`${
                      futureAvgProfit / 3 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 3).toFixed(2)}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  6 Month Average<span></span>
                </li>
                <li className="list-group-item d-flex  align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary  badgespan me-1">
                    <i className="bx bx-rupee fs-5 text-dark"></i>
                  </span>{" "}
                  {/* {monthaverg?.["6_months"]?.avgMonthlyProfit?.toFixed(2) || "-"} */}
                  <h4
                    className={`${
                      futureAvgProfit / 6 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 6).toFixed(2)}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="card">
              <ul className="list-group list-group-flush mt-0">
                <li className="list-group-item d-flex justify-content-between align-items-center headingfont">
                  1 Year Average<span></span>
                </li>
                <li className="list-group-item d-flex  align-items-center fs-5 fw-bold">
                  <span className="badge btn-primary  badgespan me-1">
                    <i className="bx bx-rupee fs-5 text-dark"></i>
                  </span>{" "}
                  {/* {monthaverg?.["12_months"]?.avgMonthlyProfit?.toFixed(2) || "-"} */}
                  <h4
                    className={`${
                      futureAvgProfit / 12 < 0 ? "text-danger" : "text-success"
                    }`}
                  >
                    {(futureAvgProfit / 12).toFixed(2)}
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {cashChartData && (
                  <Bar
                    data={cashChartData}
                    options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          display: false, // 🔹 hides the legend box
                        },
                        title: {
                          display: true,
                          text: "Future Performance (Monthly)",
                        },
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-2 mb-2">
            <div className="col-md-12">
              <div className="alert alert-primary" role="alert">
                {/* <div className="d-md-flex justify-content-between align-items-center">
                  <div>
                    Future ({months.find((m) => m.value === month)?.name} {year}
                    ) PERFORMANCE
                  </div>
                  <div className="mt-md-0 mt-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => changeMonth("prev")}
                    >
                      <i className="bx bx-left-arrow-alt"></i>{" "}
                      {
                        months[
                          (months.findIndex((m) => m.value === month) -
                            1 +
                            12) %
                            12
                        ]?.name
                      }{" "}
                      {year}
                    </button>
                    <button className="btn btn-primary">
                      {months.find((m) => m.value === month)?.name} {year}
                    </button>
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => changeMonth("next")}
                    >
                      {
                        months[
                          (months.findIndex((m) => m.value === month) + 1) % 12
                        ]?.name
                      }{" "}
                      {year} <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                </div> */}

                <div className="d-md-flex justify-content-between align-items-center">
                  <div>
                    Future ({months.find((m) => m.value === month)?.name} {year}
                    ) PERFORMANCE
                  </div>
                  <div className="mt-md-0 mt-3">
                    {/* Previous Button */}
                    <button
                      className="btn btn-primary me-2"
                      onClick={() => changeMonth("prev")}
                    >
                      <i className="bx bx-left-arrow-alt"></i>{" "}
                      {(() => {
                        const prev = getPrevMonthYear();
                        return `${prev.month} ${prev.year}`;
                      })()}
                    </button>

                    {/* Current Month */}
                    <button className="btn btn-primary">
                      {months.find((m) => m.value === month)?.name} {year}
                    </button>

                    {/* Next Button */}
                    <button
                      className="btn btn-primary ms-2"
                      onClick={() => changeMonth("next")}
                    >
                      {(() => {
                        const next = getNextMonthYear();
                        return `${next.month} ${next.year}`;
                      })()}{" "}
                      <i className="bx bx-right-arrow-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row text-white">
            <div className="col-md-4">
              <div className="card radius-10 overflow-hidden w-100">
                <div className="card-body">
                  <p className="text-light">Future</p>
                  <h4 className="mb-0 text-light">
                    {months.find((m) => m.value === month)?.name} {year}
                  </h4>
                  <hr />
                  <p className="text-light">Profit - Loss Summary</p>
                  <div className="mt-5">
                    {/* {doughnutData1 ? <Doughnut data={doughnutData1} /> : <p>Loading...</p>} */}
                    {doughnutData1 ? (
                      <Doughnut
                        data={doughnutData1}
                        options={doughnutOptions}
                      />
                    ) : (
                      <p>Loading...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card radius-10 overflow-hidden w-100 h-100">
                <div className="card-body">
                  {chartData1 ? (
                    <Bar
                      data={chartData1}
                     options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            display: false,
                          },
                          title: {
                            display: false,
                          },
                          tooltip: {
                            enabled: true,
                          },
                        },
                        scales: {
                          x: {
                            title: {
                              display: true,
                              text: "Dates",
                            },
                          },
                          y: {
                            title: {
                              display: true,
                              text: "Net Profit (%)",
                            },
                            ticks: {
                              callback: (value) => value + "%",
                            },
                          },
                        },
                      }}
                    />
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-4 text-light">
          <div className="d-md-flex gap-3">
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.totalSignals}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Profitable Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.profitableCalls}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Loss Calls</strong>
              </p>
              <h6 className="card-title">{dailydata?.lossCalls}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Profit </strong>
              </p>
              <h6 className="card-title">
                {dailydata?.totalProfit?.toFixed(2)}
              </h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Total Loss</strong>
              </p>
              <h6 className="card-title">{dailydata?.totalLoss?.toFixed(2)}</h6>
            </div>
            <div className="card-body card">
              <p className="mb-1">
                <strong>Net Profit/Loss</strong>
              </p>
              <h6 className="card-title">
                {" "}
                {(
                  (dailydata?.totalProfit || 0) - (dailydata?.totalLoss || 0)
                )?.toFixed(2)}
              </h6>
            </div>
          </div>
        </div>

        <div className="card ">
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item rounded-3 border-0 shadow mb-2">
              <h2 className="accordion-header">
                <button
                  className="accordion-button border-bottom collapsed fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="m-0">
                      Future ({months.find((m) => m.value === month)?.name}{" "}
                      {year}) RECOMMENDATIONS
                    </h5>
                  </div>
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  <div className="row  align-items-center">
                    <div className="col-md-12">
                      <Table
                        columns={columns}
                        data={dailydata?.signalList}
                        pagination
                        striped
                        highlightOnHover
                        dense
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReusableModal
          show={showModal}
          onClose={() => setShowModal(false)}
          title="Description"
          body={
            <p>{description?.description || "No description available."}</p>
          }
        />
      </div>
    </Content>
  );
};

export default Cash;
